// extracted by mini-css-extract-plugin
module.exports = {"text":"Hero_text__8M_RS","letter":"Hero_letter__0gprK"};